import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function OfferSection() {
  return <section className="py-24 bg-white relative" data-id="element-74">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-75">
        <div className="bg-brand-50 rounded-[2.5rem] p-8 md:p-12 border-2 border-brand-100 shadow-2xl relative overflow-hidden" data-id="element-76">
          {/* Decorative background elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-x-1/2 -translate-y-1/2" data-id="element-77"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-x-1/2 translate-y-1/2" data-id="element-78"></div>

          <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-79">
            <div className="order-2 md:order-1" data-id="element-80">
              <div className="inline-block bg-accent-100 text-accent-700 font-bold px-4 py-1.5 rounded-full text-sm mb-6 border border-accent-200" data-id="element-81">
                🔥 Oferta Especial por Tiempo Limitado
              </div>

              <h2 className="text-3xl md:text-4xl font-extrabold text-stone-900 mb-6 leading-tight" data-id="element-82">
                No esperes a que el próximo análisis te asuste más.
              </h2>

              <p className="text-lg text-stone-700 mb-8 font-medium" data-id="element-83">
                Empezá hoy con una guía clara, recetas simples y un plan
                práctico para volver a comer con tranquilidad.
              </p>

              <div className="bg-white rounded-2xl p-6 shadow-sm border border-stone-100 mb-8" data-id="element-84">
                <div className="flex items-end gap-4 mb-2" data-id="element-85">
                  <span className="text-5xl font-extrabold text-brand-600" data-id="element-86">
                    $14.999
                  </span>
                  <span className="text-xl text-stone-500 font-medium mb-1" data-id="element-87">
                    ARS
                  </span>
                </div>
                <p className="text-sm text-stone-500" data-id="element-88">
                  Incluye la guía principal + 6 bonos digitales gratis.
                </p>
              </div>

              <Button size="xl" className="w-full shadow-xl shadow-brand-600/20 mb-6 text-lg" data-id="element-89">
                Acceder ahora a todo el material
              </Button>

              <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-stone-500 font-medium" data-id="element-90">
                <div className="flex items-center gap-1.5" data-id="element-91">
                  <ShieldCheckIcon className="w-4 h-4 text-brand-500" data-id="element-92" />
                  Garantía de 7 días
                </div>
                <div className="flex items-center gap-1.5" data-id="element-93">
                  <LockIcon className="w-4 h-4 text-brand-500" data-id="element-94" />
                  Pago Seguro
                </div>
                <div className="flex items-center gap-1.5" data-id="element-95">
                  <CreditCardIcon className="w-4 h-4 text-brand-500" data-id="element-96" />
                  Tarjetas y MercadoPago
                </div>
              </div>
            </div>

            <div className="order-1 md:order-2 relative" data-id="element-97">
              <motion.div initial={{
              y: 10,
              opacity: 0
            }} whileInView={{
              y: 0,
              opacity: 1
            }} viewport={{
              once: true
            }} className="relative mx-auto w-full max-w-sm" data-id="element-98">
                <div className="aspect-[4/5] bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-white transform rotate-3" data-id="element-99">
                  <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-4.0.3&fit=crop&fm=webp&w=480&q=80" alt="Chau Hígado Graso Guía" width={800} height={1000} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-100" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-900/90 via-brand-900/40 to-transparent flex flex-col justify-end p-6" data-id="element-101">
                    <h3 className="text-white font-display font-bold text-2xl mb-1" data-id="element-102">
                      Chau Hígado Graso
                    </h3>
                    <p className="text-brand-200 text-sm font-medium" data-id="element-103">
                      Edición Completa + Bonos
                    </p>
                  </div>
                </div>

                {/* Discount Badge */}
                <div className="absolute -top-6 -right-6 bg-accent-500 text-white w-24 h-24 rounded-full flex flex-col items-center justify-center shadow-xl transform rotate-12 border-4 border-white" data-id="element-104">
                  <span className="text-xs font-bold uppercase tracking-wider" data-id="element-105">
                    Ahorrás
                  </span>
                  <span className="text-xl font-extrabold" data-id="element-106">55%</span>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}